import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addMagainzeCrumb } from 'redux/actions';
import AnalyticsManager from '../../../../app/analytics';
import { AnalyticsParamValues } from '../../../../constants/analytics';
import * as Routes from 'constants/routes';
import * as SHARE_TYPES from 'constants/share-types';


import LeftArrow from 'assets/magazine/icons/left-arrow.svg';

import { useGetArticleByIdQuery } from 'redux/api/content.api';

import './index.scss';
import {
    generateUniqueId,
    getDateFromUnix,
    getImageFullPath,
    reactParserCommonOptions,
} from 'app/functions';
import DealsStrip from './components/DealsStrip';
import { NavLink, useParams, useLocation } from 'react-router-dom';
import ReactParser from 'react-html-parser';
import ShareButton from './components/ShareButton';

const Article = (props) => {
    const params = useParams();
    const location = useLocation();
    const { category } = props;
    const dispatch = useDispatch();
    const [article, setArticle] = useState({});
    const magazineCategories = useSelector(store => store.data.magazineCategories);
    const text = useSelector(store => store.config.Translations);
    const { data } = useGetArticleByIdQuery(params.articleId);

    const articleBodyRef = useRef(null);

    const isMobile = useSelector(store => store.state.deviceState) === 'mobile';

    const centerOnAnchor = (event, anchorName) => {
        event.preventDefault();

        const anchorElement = articleBodyRef.current.querySelector(anchorName);

        // Center the screen on the anchor element
        if (anchorElement) {
            window.scrollTo({
                top: anchorElement.offsetTop - (window.screen.height / 4),
            });
        }
    };

    // Allow anchor links inside articles
    useLayoutEffect(() => {
        if (articleBodyRef.current) {
            const anchorLinks = articleBodyRef.current.querySelectorAll('a');

            Array.from(anchorLinks).forEach((linkElement) => {
                // Make sure this's an anchor link and not an external one
                if (linkElement?.attributes?.href?.value?.startsWith('#')) {
                    linkElement.onclick = (event) => centerOnAnchor(event, linkElement.attributes.href.value);
                }
            });
        }
    }, [article]);

    useEffect(() => {
        const breadcrumb = isMobile ? (article.header_name?.length > 25 ? article.header_name?.substring(0,12)+"...":article.header_name):article.header_name;
        dispatch(addMagainzeCrumb({
            text: category,
            route: `${Routes.magazine}/${category}`
        }))
        dispatch(addMagainzeCrumb({
            text: breadcrumb,
            route: `${Routes.magazine}/${category}/${article?.header_name}`
        }))
        let navigation = document.querySelector('.navigation-strip-wrapper');
        // navigation.classList.add('hidden');
        return () => {
            dispatch(addMagainzeCrumb({
                text: category,
                route: `${Routes.magazine}/${category}`
            }))
            dispatch(addMagainzeCrumb({
                text: breadcrumb,
                route: `${Routes.magazine}/${category}/${article?.header_name}`
            }))
            let navigation = document.querySelector('.navigation-strip-wrapper');
            // navigation.classList.remove('hidden');
        };
    }, [article, isMobile]);

    useEffect(() => {
        if (data) {
            updateState(data);
        }
    }, [data,params.articleId])

    const updateState = (data) => {
        const thisCategory = (magazineCategories.filter((cat) => cat.title === category))[0];
        if(thisCategory && data.related_category === thisCategory.id){
            setArticle(data);
        } else {
            window.location.replace(Routes.magazine);
        }
    }
    const shareLink = window.location.href;
    return (<>
    {Object.keys(article).length > 0 && (<div className='article-wrapper'>
        <div className="article-text-wrapper">
                <div className="article-header-wrapper">
                    <div className="article-headline-wrapper">
                        <div className="article-headline">
                            {article.header_name}
                        </div>

                        {article.header_sub_name && (
                            <div className="article-sub-headline">
                                {article.header_sub_name}
                            </div>
                        )}

                        <div className="article-information">
                            {article.author && (
                                <div className="article-subline">
                                    {article.author}
                                </div>
                            )}

                            <div className="article-date">
                                {getDateFromUnix(article.article_date)}
                            </div>
                        </div>
                    </div>
                    {/*<div className="article-details-wrapper">*/}
                    {/*    /!*<div className="social-share-wrapper">*!/*/}
                    {/*    /!*    <ShareButton*!/*/}
                    {/*    /!*        type={SHARE_TYPES.EMAIL}*!/*/}
                    {/*    /!*        link={shareLink}*!/*/}
                    {/*    /!*        title={article.header_name}*!/*/}
                    {/*    /!*    >*!/*/}
                    {/*    /!*        <img src={ShareMail} alt="שתף במייל" className="share-img"/>*!/*/}
                    {/*    /!*    </ShareButton>*!/*/}
                    {/*    /!*    <div className="divider"></div>*!/*/}
                    {/*    /!*    <ShareButton*!/*/}
                    {/*    /!*        type={SHARE_TYPES.WHATSAPP}*!/*/}
                    {/*    /!*        link={shareLink}*!/*/}
                    {/*    /!*        title={article.header_name}*!/*/}
                    {/*    /!*    >*!/*/}
                    {/*    /!*        <img src={ShareWA} alt="שתף בוואטסאפ" className="share-img"/>*!/*/}
                    {/*    /!*    </ShareButton>*!/*/}
                    {/*    /!*    <div className="divider"></div>*!/*/}
                    {/*    /!*    <ShareButton*!/*/}
                    {/*    /!*        type={SHARE_TYPES.FACEBOOK}*!/*/}
                    {/*    /!*        link={shareLink}*!/*/}
                    {/*    /!*        title={article.header_name}*!/*/}
                    {/*    /!*    >*!/*/}
                    {/*    /!*        <img src={ShareFB} alt="שתף בפייסבוק" className="share-img" />*!/*/}
                    {/*    /!*    </ShareButton>*!/*/}
                    {/*    /!*</div>*!/*/}
                    {/*</div>*/}
                </div>
                <div className="article-text" ref={articleBodyRef}>
                    {ReactParser(article.article_body, reactParserCommonOptions())}
                </div>
            <div className="next-previous-article">
                <NavLink to={`${Routes.magazine}/${category}/${article.adjacent_articles.previous_article_id}`} className="next-btn revert" style={{
                    visibility: article.adjacent_articles.previous_article_id !== "" ? "visible":"hidden",
                    // pointerEvents:
                }}>
                    <div>
                        {text['article_previous']}
                    </div>
                    <img src={LeftArrow} alt="חץ אחורה" className="arrow" />
                </NavLink>
                <NavLink to={`${Routes.magazine}/${category}/${article.adjacent_articles.next_article_id}`} className="next-btn" style={{
                    visibility: article.adjacent_articles.next_article_id !== "" ? "visible":"hidden",
                    // pointerEvents:
                }}>
                    <div className='text'>
                        {text['article_next']}
                    </div>
                    <img src={LeftArrow} alt="חץ קדימה" className="arrow" />
                </NavLink>
            </div>
        </div>
        <div className="article-suggestions-wrapper">
            {article.related_benefits.length > 0 && (
                <div className="deals-wrapper">
                    <div className="article-title">{text['article_deals']}</div>
                    <DealsStrip deals={article.related_benefits}/>
                </div>
            )}
            {article.last_articles.length > 0 && (
            <div className="articles-wrapper">
                <div className="article-title">{text['article_latest_articles']}</div>
                {article.last_articles.map((art) => {
                    const link = getLink(article.related_category, art.id, magazineCategories);
                    return (
                        <NavLink
                            key={"latest-articles-" + generateUniqueId(6)}
                            to={link}
                            onClick={() => AnalyticsManager.logArticlePress(
                                art?.id, art?.header_name, AnalyticsParamValues.MAGAZINE_ARTICLE_PAGE_SOURCE
                            )}
                            className="suggested-article-wrapper"
                        >
                            <div className="article-title">{art.header_name}</div>
                            <div className="subline">
                                {art.author && art.author + ' | '}
                                {getDateFromUnix(art.article_date)}
                            </div>
                        </NavLink>
                    );
            })}
            </div>)}
        </div>
    </div>)}
    </>);
}

export default Article;

const getParagraph = (para) => {
    let paragraph = [ReactParser(para.paragraph)];
    if(para.header_media_id !== ''){
        const element = (
        <div className="in-article-image-wrapper">
            <img className='image' src={getImageFullPath(para.header_media_id)} alt={para.description}/>
            {para.description !== "" && <div className="description">{para.description}</div>}
        </div>);
        paragraph.push(element);
    }
    if(para.video_link !==''){
        try {
            const searchParams = (new URL(para.video_link)).searchParams;
            const embedLink = `https://www.youtube.com/embed/${searchParams.get('v')}`;
            const element = (
                <div className="in-article-image-wrapper">
                    <iframe src={embedLink} width="100%" height="100%" referrerPolicy="strict-origin-when-cross-origin"/>
                </div>
            );
            paragraph.push(element);
        } catch (e) {

        }
    }
    paragraph = paragraph.map((pa) => <React.Fragment key={generateUniqueId(9)}>{pa}</React.Fragment>)
    return paragraph;
}

const getLink = (category, articleId, categories) => {
    const thisCategory = (categories.filter((cat) => cat.id === category))[0];
    return `${Routes.magazine}/${thisCategory.title}/${articleId}`;
}
